import {useCallback,useEffect,useRef,useState} from 'react';

export const EMAIL_RESEND_SECONDS=10*60;
const bounded=(value,fallback=0)=>Number.isFinite(Number(value))&&value!==null&&value!==undefined
  ?Math.max(0,Math.min(EMAIL_RESEND_SECONDS,Math.ceil(Number(value)))):fallback;
export const emailWaitSeconds=(data,fallback=0)=>bounded(data?.resendAfterSeconds??data?.retryAfterSeconds,fallback);
export const emailConfirmationRequired=data=>data?.code
  ?data.code==='emailConfirmationRequired'
  :String(typeof data==='string'?data:data?.message||'').trim()==='Lütfen e-posta adresinizi doğrulayın.';
export const emailCooldownResponse=(data,text='')=>data?.code==='emailCodeCooldown'||text.includes('10 dakika bekleyin');
export function useEmailResendWait(initialSeconds=0){
  const initial=bounded(initialSeconds),deadline=useRef(Date.now()+initial*1000);
  const [seconds,setSeconds]=useState(initial);
  const remaining=useCallback(()=>Math.max(0,Math.ceil((deadline.current-Date.now())/1000)),[]);
  const start=wait=>{const value=bounded(wait);deadline.current=Date.now()+value*1000;setSeconds(value);};
  useEffect(()=>{
    const tick=()=>setSeconds(remaining());
    const timer=setInterval(tick,1000);
    document.addEventListener('visibilitychange',tick);window.addEventListener('focus',tick);
    return()=>{clearInterval(timer);document.removeEventListener('visibilitychange',tick);window.removeEventListener('focus',tick);};
  },[remaining]);
  return {seconds,start,remaining};
}
export const emailWaitLabel=seconds=>Math.floor(seconds/60).toString().padStart(2,'0')+':'+(seconds%60).toString().padStart(2,'0');
export async function readAuthResponse(response){
  const text=await response.text();let data;
  try{data=JSON.parse(text);}catch{data={message:text};}
  return {text,data};
}
